module.exports = __webpack_public_path__ + "img/3.b9c64aad.jpg";